import { Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useState } from 'react';
import AppContainer from 'src/components/appComponents/AppContainer';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import { useGetAllPublishBatchJobsQuery } from 'src/graphql';
import ChannelAiPublishJobsTableRow from 'src/sections/channelAiPublishJobs/ChannelAiPublishJobsTableRow';
import ChannelAiPublishJobsTableToolbar from 'src/sections/channelAiPublishJobs/ChannelAiPublishJobsTableToolbar';
import { Add_Publish_Jobs_TABLE_HEAD } from 'src/utils/tables-headers';

export default function ChannelAiPublishJobsPage() {
  const table = useTable();
  const [search, setSearch] = useState({ subject: '', status: '' });

  const { data, isLoading } = useGetAllPublishBatchJobsQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
  });

  return (
    <AppContainer
      pageTitle="ChannelAiPublishJobs"
      routeLinks={[{ name: 'Help Center' }, { name: 'ChannelAiPublishJobs' }]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ChannelAiPublishJobsTableToolbar search={search} setSearch={setSearch} />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom headLabel={Add_Publish_Jobs_TABLE_HEAD} />
                <TableBody>
                  {isLoading
                    ? [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    : data?.getPublishBatchJobs?.items?.map((row: any) => (
                        <ChannelAiPublishJobsTableRow key={row.id} row={row} />
                      ))}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={data?.total_count ?? 0}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
